import * as partCRUD from "./partCRUD";
import * as typeCrud from "./partTypeCRUD";
import * as viewCrud from "./viewCRUD";
export default { ...partCRUD, ...typeCrud, ...viewCrud };
